module.exports = __webpack_public_path__ + "img/h5-1.27f2a510.png";